<template>
  <v-form>
    <v-container fluid>
      <v-row>


        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.model"
            :error-messages="modelErrors"
            :label="$t('profile.industrialcomputer.model')"
            required
            @input="$v.item.model.$touch()"
            @blur="$v.item.model.$touch()"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <p>Format : x.x.x (1.0.0, 1.2.1, 1.0.0-ALPHA.1, 1.0.0-R.1, ...)</p>
          <v-text-field
            v-model="item.version"
            :error-messages="versionErrors"
            :label="$t('profile.industrialcomputer.version')"
            required
            @input="$v.item.version.$touch()"
            @blur="$v.item.version.$touch()"
          />
        </v-col>

      </v-row>
      <v-row>

        <v-col cols="12" sm="6" md="6"  v-if="!item['@id']">
          <v-combobox
            v-if="industrialcomputerSelectItems"
            v-model="item.parent"
            :items="industrialcomputerSelectItems"
            :error-messages="parentErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            :label="$t('profile.industrialcomputer.parent')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="operatingSystemSelectItems"
            v-model="item.operatingSystem"
            :items="operatingSystemSelectItems"
            :error-messages="operatingSystemErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.operatingsystem.operatingsystem')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <strong class="ml-4" >{{ $t('global.archive') }}:</strong>
          <v-switch
                v-model="item.archive"
                :error-messages="archiveErrors"
              ></v-switch>
        </v-col>
      </v-row>

    </v-container>
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'IndustrialComputerForm',
  mixins: [validationMixin],
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
      this.industrialcomputerGetSelectItems({'query'  : [{'id': 'exists[parent]', 'value': 0 }]  });
      this.operatingSystemGetSelectItems();
  },
  data() {
    return {
        model: null,
        version: null,
        parent: null,
        operatingSystem: null,
        archive: null,
    };
  },
  computed: {

    isLoading() {
      return (this.isLoading_industrialcomputer ||
        this.isLoading_operatingSystem
       );
    },
    ...mapFields('industrialcomputer', {
      industrialcomputerSelectItems: 'selectItems',
      isLoading_industrialcomputer : 'isLoading'
    }),
    ...mapFields('operatingsystem', {
      operatingSystemSelectItems: 'selectItems',
      isLoading_operatingSystem : 'isLoading'
    }),

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },
    modelErrors() {
      const errors = [];

      if (!this.$v.item.model.$dirty) return errors;

      has(this.violations, 'model') && errors.push(this.violations.model);

      !this.$v.item.model.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    versionErrors() {
      const errors = [];

      if (!this.$v.item.version.$dirty) return errors;

      has(this.violations, 'version') && errors.push(this.violations.version);

      !this.$v.item.version.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    parentErrors() {
      const errors = [];

      if (!this.$v.item.parent.$dirty) return errors;

      has(this.violations, 'parent') && errors.push(this.violations.parent);


      return errors;
    },
    operatingSystemErrors() {
      const errors = [];
      if (!this.$v.item.operatingSystem.$dirty) return errors;
      has(this.violations, 'operatingSystem') && errors.push(this.violations.operatingSystem);
      return errors;
    },
    archiveErrors() {
      const errors = [];
      if (!this.$v.item.archive.$dirty) return errors;
      has(this.violations, 'archive') && errors.push(this.violations.archive);
      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  methods: {
      ...mapActions({
        industrialcomputerGetSelectItems: 'industrialcomputer/fetchSelectItems'
      }),
      ...mapActions({
        operatingSystemGetSelectItems: 'operatingsystem/fetchSelectItems'
      }),
  },
  validations: {
    item: {
      model: {
        required,
      },
      version: {
        required,
      },
      parent: {
      },
      operatingSystem: {
      },
      archive: {

      },
    }
  }
};
</script>
